import { jsx as e } from "react/jsx-runtime";
import { Rectangle as t } from "recharts";
const r = (r2) => {
  const { index: l, dataKey: a, data: u, keys: o } = r2;
  if (!u || "number" != typeof l) return null;
  const n = u[l];
  if (!n) return null;
  const s = o.map((e2) => ({ key: e2, value: n[e2] }));
  let i = 0, v = 0;
  const f = s.map((e2) => {
    const t2 = e2.value >= 0 ? i : v, r3 = t2 + e2.value;
    return e2.value >= 0 ? i = r3 : v = r3, { key: e2.key, from: t2, to: r3, value: e2.value };
  }).filter((e2) => 0 !== e2.value).sort((e2, t2) => e2.to - t2.to), y = f[0], m = f[f.length - 1];
  let c = [0, 0, 0, 0];
  if (m && y) if (m.value > 0 && y.value > 0) {
    c = a === m.key ? [8, 8, 0, 0] : c;
  } else if (y.value < 0 && m.value < 0) {
    c = a === y.key ? [8, 8, 0, 0] : c;
  } else c = a === y.key || a === m.key ? [8, 8, 0, 0] : c;
  return e(t, { ...r2, radius: c });
};
export {
  r as RoundedBar
};
//# sourceMappingURL=RoundedBar.js.map
